{
  "name": "emaan-reviver-ui",
  "version": "1.2.0",
  "description": "",
  "source": "/src/index.html",
  "scripts": {
    "dev": "parcel --open -p 4000",
    "build": "parcel build",
    "build:dev": "REACT_APP_ENV=dev parcel build",
    "build:stage": "REACT_APP_ENV=stage parcel build",
    "build:prod": "REACT_APP_ENV=prod parcel build",
    "build:devsite": "REACT_APP_ENV=devsite parcel build",
    "build:prodsite": "REACT_APP_ENV=prodsite parcel build",
    "format": "eslint . --fix",
    "lint": "eslint .",
    "prepare": "husky install"
  },
  "repository": {
    "type": "git",
    "url": "git@github.com-ahmed:Emaan-Reviver/Emaanreviver-website.git"
  },
  "keywords": [],
  "author": "",
  "license": "ISC",
  "standard-version": {
    "skip": {
      "commit": true,
      "tag": true
    },
    "types": [
      {
        "type": "feat",
        "section": "Features"
      },
      {
        "type": "fix",
        "section": "Bug Fixes"
      },
      {
        "type": "perf",
        "section": "Performance Improvements"
      },
      {
        "type": "refactor",
        "section": "Maintenance Improvements"
      }
    ]
  },
  "dependencies": {
    "@emotion/react": "^11.11.1",
    "@emotion/styled": "^11.11.0",
    "@mui/icons-material": "^7.3.7",
    "@mui/material": "^7.3.7",
    "axios": "^1.0.0",
    "moment": "^2.29.0",
    "prop-types": "^15.8.1",
    "react": "^19.2.3",
    "react-dom": "^19.2.3",
    "react-router-dom": "^6.28.0"
  },
  "devDependencies": {
    "@babel/core": "^7.11.6",
    "@babel/eslint-parser": "^7.19.1",
    "@babel/plugin-proposal-class-properties": "^7.18.6",
    "@babel/plugin-proposal-throw-expressions": "^7.22.5",
    "@babel/plugin-syntax-dynamic-import": "^7.8.3",
    "@babel/plugin-syntax-jsx": "^7.22.5",
    "@babel/plugin-transform-react-jsx": "^7.12.13",
    "@babel/plugin-transform-runtime": "^7.22.5",
    "@babel/polyfill": "^7.12.1",
    "@babel/preset-react": "^7.28.5",
    "@commitlint/cli": "^20.3.1",
    "@commitlint/config-conventional": "^20.3.1",
    "@eslint/js": "^9.39.2",
    "@parcel/reporter-bundle-analyzer": "^2.9.2",
    "@parcel/resolver-default": "^2.16.3",
    "@parcel/transformer-sass": "^2.9.3",
    "babel-core": "^6.26.3",
    "babel-jest": "^30.2.0",
    "buffer": "^5.5.0||^6.0.0",
    "eslint": "^9.39.2",
    "eslint-config-airbnb-base": "^15.0.0",
    "eslint-config-jest-enzyme": "^7.1.2",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-babel": "^5.3.1",
    "eslint-plugin-import": "^2.26.0",
    "eslint-plugin-jest": "^29.12.1",
    "eslint-plugin-jsx-a11y": "^6.6.1",
    "eslint-plugin-prettier": "^5.1.3",
    "eslint-plugin-react": "^7.31.8",
    "eslint-plugin-react-hooks": "^7.0.1",
    "git-list-updated": "^1.2.1",
    "globals": "^17.0.0",
    "husky": "^9.0.11",
    "jest": "^30.2.0",
    "lint-staged": "^16.2.7",
    "os-browserify": "^0.3.0",
    "parcel": "^2.9.3",
    "parcel-reporter-static-files-copy": "^1.5.0",
    "path": "^0.12.7",
    "path-browserify": "^1.0.0",
    "prettier": "^3.2.5",
    "react-test-renderer": "^19.2.3"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "since 2017-06"
    ]
  },
  "buildDate": 1667661146107
}
